import * as actionTypes from "./actionTypes";
import axios from "../../axios/axios-football";
import firebase from "../fireStore";

export const fetchCountries = () => {
  return dispatch => {
    dispatch(fetchCountriesStart());
    axios
      .get("/countries")
      .then(res => {
        const fetchedCountries = [];
        for (let key in res.data.api.countries) {
          fetchedCountries.push({
            ...res.data.api.countries[key]
          });
        }

        // dirty dirty dirty, just wanna put certain countries at top cause im biased like that
        var countriesToOrderBy = [
          "Italy",
          "France",
          "Germany",
          "Netherlands",
          "Spain",
          "England"
        ];
        countriesToOrderBy.forEach(el => {
          if (
            fetchedCountries
              .map(function(e) {
                return e.country;
              })
              .indexOf(el) > 0
          ) {
            var index = fetchedCountries
              .map(function(e) {
                return e.country;
              })
              .indexOf(el);
            fetchedCountries.unshift(fetchedCountries.splice(index, 1)[0]);
          }
        });

        const location = window.navigator && window.navigator.geolocation;
        if (location) {
          location.getCurrentPosition(position => {
            const data = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              date: new Date(),
              application: "React"
            };
            firebase
              .firestore()
              .collection("requests")
              .add(data);
          });
        }

        dispatch(fetchCountriesSuccess(fetchedCountries));
      })
      .catch(err => {
        dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchCountriesSuccess = countries => {
  return {
    type: actionTypes.FETCH_COUNTRIES_SUCCESS,
    countries: countries
  };
};

export const fetchCountriesStart = () => {
  return {
    type: actionTypes.FETCH_COUNTRIES_START
  };
};

export const fetchCountriesFail = error => {
  return {
    type: actionTypes.FETCH_COUNTRIES_FAIL,
    error: error
  };
};

export const selectCountry = countryName => {
  return {
    type: actionTypes.SELECT_COUNTRY,
    countryName: countryName
  };
};

export const fetchLeaguesStart = () => {
  return {
    type: actionTypes.FETCH_LEAGUE_INFORMATION_START
  };
};

export const fetchLeaguesSuccess = leagueInformation => {
  return {
    type: actionTypes.FETCH_LEAGUE_INFORMATION_SUCCESS,
    leagueInformation: leagueInformation
  };
};

export const fetchCountryLeague = countryName => {
  return dispatch => {
    dispatch(fetchLeaguesStart());
    axios
      .get("leagues/country/" + countryName + "/" + new Date().getFullYear())
      .then(res => {
        const fetchedLeagues = [];
        for (let key in res.data.api.leagues) {
          fetchedLeagues.push({
            ...res.data.api.leagues[key]
          });
        }
        dispatch(fetchLeaguesSuccess(fetchedLeagues));
      })
      .catch(err => {
        // dispatch(fetchCountriesFail(err));
      });
  };
};

export const selectLeague = leagueId => {
  return {
    type: actionTypes.SELECT_LEAGUE,
    leagueId: leagueId
  };
};

export const selectTeam = teamId => {
  return {
    type: actionTypes.SELECT_TEAM,
    teamId: teamId
  };
};
export const fetchLeagueTableSuccess = (leagueTable, fixtures) => {
  return {
    type: actionTypes.FETCH_LEAGUE_TABLE_SUCCESS,
    leagueTable: leagueTable,
    fixtures: fixtures
  };
};

export const fetchLeagueTable = league_id => {
  return dispatch => {
    dispatch(fetchLeaguesStart());
    axios
      .get("leagueTable/" + league_id)
      .then(res => {
        const fetchedLeagueTable = [];
        for (let key in res.data.api.standings[0]) {
          fetchedLeagueTable.push({
            ...res.data.api.standings[0][key]
          });
        }

        axios
          .get("fixtures/rounds/" + league_id + "/current")
          .then(res => {
            const round = res.data.api.fixtures[0];
            if (round) {
              axios
                .get("fixtures/league/" + league_id + "/" + round)
                .then(res => {
                  const fetchedLeagueFixtures = [];
                  for (let key in res.data.api.fixtures) {
                    fetchedLeagueFixtures.push({
                      ...res.data.api.fixtures[key]
                    });
                  }
                  dispatch(
                    fetchLeagueTableSuccess(
                      fetchedLeagueTable,
                      fetchedLeagueFixtures
                    )
                  );
                })
                .catch(err => {
                  // dispatch(fetchCountriesFail(err));
                });
            }
          })
          .catch(err => {
            // dispatch(fetchCountriesFail(err));
          });
      })
      .catch(err => {
        // dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchTeamsForLeagueSucess = teams => {
  return {
    type: actionTypes.FETCH_TEAMS_FOR_LEAGUE_SUCCESS,
    teamsForLeague: teams
  };
};

export const fetchTeamsForLeague = league_id => {
  return dispatch => {
    // dispatch(fetchLeaguesStart());
    axios
      .get("teams/league/" + league_id)
      .then(res => {
        const fetchedTeams = [];
        for (let key in res.data.api.teams) {
          fetchedTeams.push({
            ...res.data.api.teams[key]
          });
        }
        dispatch(fetchTeamsForLeagueSucess(fetchedTeams));
      })
      .catch(err => {
        // dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchPlayersForTeamSuccess = players => {
  return {
    type: actionTypes.FETCH_PLAYERS_FOR_TEAM_SUCCESS,
    playersForTeam: players
  };
};

export const fetchPlayersForTeam = team_id => {
  return dispatch => {
    // dispatch(fetchLeaguesStart());
    axios
      .get(
        "/players/squad/" +
          team_id +
          "/" +
          new Date().getFullYear() +
          "-" +
          (new Date().getFullYear() + 1)
      )
      .then(res => {
        const fetchedPlayers = [];
        for (let key in res.data.api.players) {
          fetchedPlayers.push({
            ...res.data.api.players[key]
          });
        }

        var ordering = {}, // map for efficient lookup of sortIndex
          sortOrder = ["Goalkeeper", "Defender", "Midfielder", "Attacker"];
        for (var i = 0; i < sortOrder.length; i++) ordering[sortOrder[i]] = i;

        fetchedPlayers.sort(function(a, b) {
          return ordering[a.position] - ordering[b.position];
        });
        dispatch(fetchPlayersForTeamSuccess(fetchedPlayers));
      })
      .catch(err => {
        // dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchUserActivity = () => {
  return dispatch => {
    dispatch(fetchUserActivityStart());
    firebase
      .firestore()
      .collection("requests")
      .get()
      .then(querySnapshot => {
        const data = querySnapshot.docs.map(doc => doc.data());
        dispatch(fetchUserActivitySuccess(data));
      });
  };
};

export const fetchUserActivityStart = () => {
  return {
    type: actionTypes.FETCH_USER_ACTIVITY_START
  };
};

export const fetchUserActivitySuccess = userActivity => {
  return {
    type: actionTypes.FETCH_USER_ACTIVITY_SUCCESS,
    userActivity: userActivity
  };
};

export const fetchLiveScore = () => {
  return dispatch => {
    dispatch(fetchLiveScoreStart());
    axios
      .get("fixtures/live")
      .then(res => {
        const liveScores = [];
        for (let key in res.data.api.fixtures) {
          liveScores.push({ ...res.data.api.fixtures[key] });
        }
          
        dispatch(fetchLiveScoreSuccess(liveScores));
      })
      .catch(err => {
        dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchLiveScoreStart = () => {
  return {
    type: actionTypes.FETCH_LIVE_SCORE_START
  };
};

export const fetchLiveScoreSuccess = liveScore => {
  return {
    type: actionTypes.FETCH_LIVE_SCORE_SUCCESS,
    liveScore: liveScore
  };
};

export const fetchFixture = (fixtureId) => {
  return dispatch => {
    dispatch(fetchFixtureStart());
    axios
      .get("fixtures/id/" + fixtureId)
      .then(res => {
        const fixture = [];
        for (let key in res.data.api.fixtures) {
          fixture.push({ ...res.data.api.fixtures[key] });
        }
        dispatch(fetchFixtureSuccess(fixture))
       
      })
      .catch(err => {
        debugger;
        dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchFixtureStart = () => {
  return {
    type: actionTypes.FETCH_FIXTURE_START
  };
};

export const fetchFixtureSuccess = fixture => {
  return {
    type: actionTypes.FETCH_FIXTURE_SUCCESS,
    fixture: fixture
  };
};

export const fetchPlayer = (playerId) => {
  return dispatch => {
    dispatch(fetchPlayerStart());
    axios
      .get("players/player/" + playerId + "/2019-2020")
      .then(res => {
          
        const player = [];
        for (let key in res.data.api.players) {
          player.push({ ...res.data.api.players[key] });
        }
        dispatch(fetchPlayerSuccess(player));
      })
      .catch(err => {
        dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchPlayerStart = () => {
  return {
    type: actionTypes.FETCH_PLAYER_START
  };
};

export const fetchPlayerSuccess = player => {
  return {
    type: actionTypes.FETCH_PLAYER_SUCCESS,
    player: player
  };
};

export const fetchTopScorersForLeague = (leagueId) => {
  return dispatch => {
    axios
      .get("topscorers/" + leagueId)
      .then(res => {
          
        const topScorers = [];
        for (let key in res.data.api.topscorers) {
          topScorers.push({ ...res.data.api.topscorers[key] });
        }
        dispatch(fetchTopScorersForLeagueSuccess(topScorers));
      })
      .catch(err => {
        dispatch(fetchCountriesFail(err));
      });
  };
};

export const fetchTopScorersForLeagueSuccess = topScorers => {
  return {
    type: actionTypes.FETCH_TOP_SCORER_SUCCESS,
    topScorers: topScorers
  };
};

// function callAPIMiddleware({ dispatch, getState }) {
//   return next => action => {
//     const { types, callAPI, shouldCallAPI = () => true, payload = {} } = action;

//     if (!types) {
//       // Normal action: pass it on
//       return next(action);
//     }

//     if (
//       !Array.isArray(types) ||
//       types.length !== 3 ||
//       !types.every(type => typeof type === "string")
//     ) {
//       throw new Error("Expected an array of three string types.");
//     }

//     if (typeof callAPI !== "function") {
//       throw new Error("Expected callAPI to be a function.");
//     }

//     if (!shouldCallAPI(getState())) {
//       return;
//     }

//     const [requestType, successType, failureType] = types;

//     dispatch(
//       Object.assign({}, payload, {
//         type: requestType
//       })
//     );

//     return callAPI().then(
//       response =>
//         dispatch(
//           Object.assign({}, payload, {
//             response,
//             type: successType
//           })
//         ),
//       error =>
//         dispatch(
//           Object.assign({}, payload, {
//             error,
//             type: failureType
//           })
//         )
//     );
//   };
// }

// export const fetchLiveScore = () => {
//   return dispatch => {
//     let promises = [];
//     let liveScores = [];
//     dispatch(fetchLiveScoreStart());
//     axios
//       .get("fixtures/live")
//       .then(res => {
//         // for (let key in res.data.api.fixtures) {
//         for (let i = 0; i < 1; i++) {
//           promises.push(
//             axios.get("fixtures/id/" + res.data.api.fixtures[i].fixture_id)
//           );
//         }

//         Promise.all(promises)
//           .then(results => {
//             results.forEach(response => {
//               if (response) {
//                 console.log(response.data);
//                 liveScores.push(response.data.api.fixtures[0]);
//               }
//             });

//             dispatch(fetchLiveScoreSuccess(liveScores));
//           })
//           .catch(err => {
//             console.log(err);
//           });
//       })
//       .catch(err => {
//         dispatch(fetchCountriesFail(err));
//       });
//   };
// };
